import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M12.3027 8.24609L15.333 5.19141L23.4082 13.333L18.3633 18.4199L15.333 15.3643L12.3027 18.4199L8.66601 14.7529L5.63672 17.8086L0.591797 12.7227L8.66699 4.58008L12.3027 8.24609ZM13.0117 10.3701L13.0127 10.3711L10.0742 13.333L12.3027 15.5791L15.333 12.5244L18.3633 15.5791L20.5908 13.333L15.333 8.03125L13.0117 10.3701ZM3.4082 12.7217L5.63574 14.9678L10.8945 9.66602L8.66601 7.41992L3.4082 12.7217Z"}}]};

const LogoTencentmeeting = Vue.extend<IconProps>({
  name: 'LogoTencentmeetingIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'logo-tencentmeeting',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default LogoTencentmeeting;
